/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createOrderItem = /* GraphQL */ `
  mutation CreateOrderItem(
    $input: CreateOrderItemInput!
    $condition: ModelOrderItemConditionInput
  ) {
    createOrderItem(input: $input, condition: $condition) {
      id
      customerNumber
      email
      printManufacturer
      notificationAt
      billingAdress {
        companyName
        addressLine1
        addressLine2
        street
        zipCode
        city
        country
        phone
      }
      shippingAdress {
        companyName
        addressLine1
        addressLine2
        street
        zipCode
        city
        country
        phone
      }
      status
      files {
        key
        name
      }
      furtherInfo
      furtherInfoFlowingMotifs
      furtherInfoQualityCheck
      positions {
        articleNumber
        articleName
        quantity
        productGroup
        widthByMm
        heightByMm
        White
        positionImage {
          key
          pdfKey
          quantity
          thumbnail
          filledPositionArticleNumber
          size
          comment
          approvalStatus
          acceptedDescription
          rejectedReason
          rejectedDescription
          fullName
          files {
            key
            name
          }
        }
      }
      chooseUpload
      deliveryDate
      uploadedDate
      createdAt
      language
      lastOpened
      manufacturerNote
      internalNote
      shippingMethod
      zollanmeldung
      activityLogs {
        items {
          id
          operation
          field
          value
          positionImage {
            key
            pdfKey
            quantity
            thumbnail
            filledPositionArticleNumber
            size
            comment
            approvalStatus
            acceptedDescription
            rejectedReason
            rejectedDescription
            fullName
            files {
              key
              name
            }
          }
          updatedBy
          createdAt
          updatedAt
          typename
          orderItemActivityLogsId
        }
        nextToken
      }
      lastUpdatedBy
      typename
      updatedAt
    }
  }
`;
export const updateOrderItem = /* GraphQL */ `
  mutation UpdateOrderItem(
    $input: UpdateOrderItemInput!
    $condition: ModelOrderItemConditionInput
  ) {
    updateOrderItem(input: $input, condition: $condition) {
      id
      customerNumber
      email
      printManufacturer
      notificationAt
      billingAdress {
        companyName
        addressLine1
        addressLine2
        street
        zipCode
        city
        country
        phone
      }
      shippingAdress {
        companyName
        addressLine1
        addressLine2
        street
        zipCode
        city
        country
        phone
      }
      status
      files {
        key
        name
      }
      furtherInfo
      furtherInfoFlowingMotifs
      furtherInfoQualityCheck
      positions {
        articleNumber
        articleName
        quantity
        productGroup
        widthByMm
        heightByMm
        White
        positionImage {
          key
          pdfKey
          quantity
          thumbnail
          filledPositionArticleNumber
          size
          comment
          approvalStatus
          acceptedDescription
          rejectedReason
          rejectedDescription
          fullName
          files {
            key
            name
          }
        }
      }
      chooseUpload
      deliveryDate
      uploadedDate
      createdAt
      language
      lastOpened
      manufacturerNote
      internalNote
      shippingMethod
      zollanmeldung
      activityLogs {
        items {
          id
          operation
          field
          value
          positionImage {
            key
            pdfKey
            quantity
            thumbnail
            filledPositionArticleNumber
            size
            comment
            approvalStatus
            acceptedDescription
            rejectedReason
            rejectedDescription
            fullName
            files {
              key
              name
            }
          }
          updatedBy
          createdAt
          updatedAt
          typename
          orderItemActivityLogsId
        }
        nextToken
      }
      lastUpdatedBy
      typename
      updatedAt
    }
  }
`;
export const deleteOrderItem = /* GraphQL */ `
  mutation DeleteOrderItem(
    $input: DeleteOrderItemInput!
    $condition: ModelOrderItemConditionInput
  ) {
    deleteOrderItem(input: $input, condition: $condition) {
      id
      customerNumber
      email
      printManufacturer
      notificationAt
      billingAdress {
        companyName
        addressLine1
        addressLine2
        street
        zipCode
        city
        country
        phone
      }
      shippingAdress {
        companyName
        addressLine1
        addressLine2
        street
        zipCode
        city
        country
        phone
      }
      status
      files {
        key
        name
      }
      furtherInfo
      furtherInfoFlowingMotifs
      furtherInfoQualityCheck
      positions {
        articleNumber
        articleName
        quantity
        productGroup
        widthByMm
        heightByMm
        White
        positionImage {
          key
          pdfKey
          quantity
          thumbnail
          filledPositionArticleNumber
          size
          comment
          approvalStatus
          acceptedDescription
          rejectedReason
          rejectedDescription
          fullName
          files {
            key
            name
          }
        }
      }
      chooseUpload
      deliveryDate
      uploadedDate
      createdAt
      language
      lastOpened
      manufacturerNote
      internalNote
      shippingMethod
      zollanmeldung
      activityLogs {
        items {
          id
          operation
          field
          value
          positionImage {
            key
            pdfKey
            quantity
            thumbnail
            filledPositionArticleNumber
            size
            comment
            approvalStatus
            acceptedDescription
            rejectedReason
            rejectedDescription
            fullName
            files {
              key
              name
            }
          }
          updatedBy
          createdAt
          updatedAt
          typename
          orderItemActivityLogsId
        }
        nextToken
      }
      lastUpdatedBy
      typename
      updatedAt
    }
  }
`;
export const createManufacturer = /* GraphQL */ `
  mutation CreateManufacturer(
    $input: CreateManufacturerInput!
    $condition: ModelManufacturerConditionInput
  ) {
    createManufacturer(input: $input, condition: $condition) {
      id
      name
      email
      createdAt
      typename
      updatedAt
    }
  }
`;
export const updateManufacturer = /* GraphQL */ `
  mutation UpdateManufacturer(
    $input: UpdateManufacturerInput!
    $condition: ModelManufacturerConditionInput
  ) {
    updateManufacturer(input: $input, condition: $condition) {
      id
      name
      email
      createdAt
      typename
      updatedAt
    }
  }
`;
export const deleteManufacturer = /* GraphQL */ `
  mutation DeleteManufacturer(
    $input: DeleteManufacturerInput!
    $condition: ModelManufacturerConditionInput
  ) {
    deleteManufacturer(input: $input, condition: $condition) {
      id
      name
      email
      createdAt
      typename
      updatedAt
    }
  }
`;
export const createActivityLog = /* GraphQL */ `
  mutation CreateActivityLog(
    $input: CreateActivityLogInput!
    $condition: ModelActivityLogConditionInput
  ) {
    createActivityLog(input: $input, condition: $condition) {
      id
      operation
      field
      value
      positionImage {
        key
        pdfKey
        quantity
        thumbnail
        filledPositionArticleNumber
        size
        comment
        approvalStatus
        acceptedDescription
        rejectedReason
        rejectedDescription
        fullName
        files {
          key
          name
        }
      }
      updatedBy
      createdAt
      updatedAt
      typename
      orderItemActivityLogsId
    }
  }
`;
export const updateActivityLog = /* GraphQL */ `
  mutation UpdateActivityLog(
    $input: UpdateActivityLogInput!
    $condition: ModelActivityLogConditionInput
  ) {
    updateActivityLog(input: $input, condition: $condition) {
      id
      operation
      field
      value
      positionImage {
        key
        pdfKey
        quantity
        thumbnail
        filledPositionArticleNumber
        size
        comment
        approvalStatus
        acceptedDescription
        rejectedReason
        rejectedDescription
        fullName
        files {
          key
          name
        }
      }
      updatedBy
      createdAt
      updatedAt
      typename
      orderItemActivityLogsId
    }
  }
`;
export const deleteActivityLog = /* GraphQL */ `
  mutation DeleteActivityLog(
    $input: DeleteActivityLogInput!
    $condition: ModelActivityLogConditionInput
  ) {
    deleteActivityLog(input: $input, condition: $condition) {
      id
      operation
      field
      value
      positionImage {
        key
        pdfKey
        quantity
        thumbnail
        filledPositionArticleNumber
        size
        comment
        approvalStatus
        acceptedDescription
        rejectedReason
        rejectedDescription
        fullName
        files {
          key
          name
        }
      }
      updatedBy
      createdAt
      updatedAt
      typename
      orderItemActivityLogsId
    }
  }
`;
